export default class Student {
    constructor({
        id = null,
        uco = null,
        semester_id = null
    }) {
        this.id = id;
        this.uco = uco;
        this.semester_id = semester_id;
    }

    // Basic validation for student data
    static validate(studentData) {
        if (!studentData.uco) {
            throw new Error('UCO is required');
        }
        if (!studentData.semester_id) {
            throw new Error('Semester ID is required');
        }
    }
}
